export default __webpack_public_path__ + "static/media/bar-companies.23484596.svg";